import React, { useState } from 'react';
import {
  Box,
  Heading,
  VStack,
  HStack,
  Text,
  Button,
  AspectRatio,
  Grid,
  GridItem,
  Divider,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideo, faList, faPlayCircle } from '@fortawesome/free-solid-svg-icons';

// รายการวิดีโอ (เหมือนเดิม)
const videoList = [
  {
    title: 'วิดีโอสาธิตการใช้งานระบบวันที่ 16 มิถุนายน 2568',
    description: 'เรียนรู้วิธีการใช้งานฟีเจอร์หลักและการตั้งค่าต่างๆ',
    url: '/videos/tv20250616p1.mp4',
  },
  {
    title: 'วิดีโอสาธิตการใช้งานระบบวันที่ 17 มิถุนายน 2568 (ช่วงที่ 1)',
    description: 'เรียนรู้วิธีการใช้งานฟีเจอร์หลักและการตั้งค่าต่างๆ',
    url: '/videos/tv20250617p1.mp4',
  },
  {
    title: 'วิดีโอสาธิตการใช้งานระบบวันที่ 17 มิถุนายน 2568 (ช่วงที่ 2)',
    description: 'เรียนรู้วิธีการใช้งานฟีเจอร์หลักและการตั้งค่าต่างๆ',
    url: '/videos/tv20250617p2.mp4',
  },
  {
    title: 'วิดีโอสาธิตการใช้งานระบบวันที่ 18 มิถุนายน 2568 (ช่วงที่ 1)',
    description: 'เรียนรู้วิธีการใช้งานฟีเจอร์หลักและการตั้งค่าต่างๆ',
    url: '/videos/tv20250618p1.mp4',
  },
  {
    title: 'วิดีโอสาธิตการใช้งานระบบวันที่ 18 มิถุนายน 2568 (ช่วงที่ 2)',
    description: 'เรียนรู้วิธีการใช้งานฟีเจอร์หลักและการตั้งค่าต่างๆ',
    url: '/videos/tv20250618p2.mp4',
  },
  {
    title: 'วิดีโอสาธิตการใช้งานระบบวันที่ 18 มิถุนายน 2568 (ช่วงที่ 3)',
    description: 'เรียนรู้วิธีการใช้งานฟีเจอร์หลักและการตั้งค่าต่างๆ',
    url: '/videos/tv20250618p3.mp4',
  },
  
];

const VideoPlayerPage = () => {
  // --- 1. แก้ไข State เริ่มต้น ---
  // เปลี่ยนค่าเริ่มต้นให้เป็น null เพื่อไม่ให้มีวิดีโอที่ถูกเลือกในตอนแรก
  const [currentVideo, setCurrentVideo] = useState(null);

  const handleVideoSelect = (video) => {
    setCurrentVideo(video);
  };

  return (
    <Box p={{ base: 4, md: 8 }}>
      <VStack spacing={8} align="stretch">
        <Box textAlign="center">
          <Heading as="h1" size="xl">
            วิดีโอสาธิตการใช้งาน
          </Heading>
          <Text color="gray.500">
            เลือกวิดีโอที่คุณสนใจจากรายการด้านล่าง
          </Text>
        </Box>

        <Grid
          templateColumns={{ base: '1fr', lg: '3fr 1.5fr' }}
          gap={8}
        >
          {/* --- 2. แก้ไขส่วนของ Video Player --- */}
          <GridItem>
            {/* ใช้เงื่อนไขเพื่อเลือกว่าจะแสดง Player หรือ Placeholder */}
            {currentVideo ? (
              // ถ้ามี currentVideo (ผู้ใช้เลือกแล้ว) ให้แสดง Player
              <VStack spacing={4} align="stretch">
                <Box
                  borderWidth={1}
                  borderRadius="lg"
                  boxShadow="lg"
                  overflow="hidden"
                >
                  <AspectRatio ratio={16 / 9}>
                    <video
                      src={currentVideo.url}
                      controls
                      autoPlay
                      key={currentVideo.url}
                      style={{ width: '100%', height: '100%' }}
                    >
                      เบราว์เซอร์ของคุณไม่รองรับวิดีโอแท็ก
                    </video>
                  </AspectRatio>
                </Box>
                <Box p={4} borderWidth={1} borderRadius="lg" bg="white">
                  <Heading as="h2" size="lg">{currentVideo.title}</Heading>
                  {/*<Text mt={2} color="gray.600">{currentVideo.description}</Text>*/}
                </Box>
              </VStack>
            ) : (
              // ถ้ายังไม่มี currentVideo (ตอนโหลดหน้าครั้งแรก) ให้แสดง Placeholder
              <Box
                borderWidth="2px"
                borderStyle="dashed"
                borderRadius="lg"
                p={10}
                h={{ base: '250px', md: '100%' }}
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                bg="gray.50"
              >
                <VStack spacing={4}>
                  <FontAwesomeIcon as={faPlayCircle} boxSize="50px" color="gray.300" />
                  <Heading size="md" color="gray.500">
                    ยังไม่ได้เลือกวิดีโอ
                  </Heading>
                  <Text color="gray.500">
                    กรุณาเลือกวิดีโอจากรายการทางด้านขวาเพื่อเริ่มรับชม
                  </Text>
                </VStack>
              </Box>
            )}
          </GridItem>

          {/* ส่วนของรายการวิดีโอ (Playlist) */}
          <GridItem>
            <Box borderWidth={1} borderRadius="lg" p={5} boxShadow="lg" bg="white">
              <HStack mb={4}>
                <FontAwesomeIcon icon={faList} />
                <Heading as="h3" size="md">
                  รายการวิดีโอทั้งหมด
                </Heading>
              </HStack>
              <Divider />
              <VStack spacing={4} align="stretch" mt={4}>
                {videoList.map((video) => (
                  <Button
                    key={video.url}
                    onClick={() => handleVideoSelect(video)}
                    // เพิ่มเงื่อนไข `currentVideo &&` เพื่อป้องกัน error ตอนเริ่มที่ค่าเป็น null
                    colorScheme={currentVideo && currentVideo.url === video.url ? 'iBlue' : 'iTeal'}
                    justifyContent="flex-start"
                    p={6}
                    h="auto"
                    textAlign="left"
                    minWidth={'100%'}
                  >
                    <HStack>
                      <FontAwesomeIcon icon={faVideo} />
                      <Text as="span" whiteSpace="normal">{video.title}</Text>
                    </HStack>
                  </Button>
                ))}
              </VStack>
            </Box>
          </GridItem>
        </Grid>
      </VStack>
    </Box>
  );
};

export default VideoPlayerPage;